import { useState } from 'react';
import {
  PaymentConfig,
  PaymentConfigAllowPatientSubmit,
  PaymentConfigCategory,
  PaymentConfigSubcategory,
  ExpenseCategory,
  ProtocolRewardConfig,
} from '../../models/paymentConfig';
import getPaymentCategories from '../../services/rewardConfig/getPaymentCategories';
import getPaymentSubcategories from '../../services/rewardConfig/getPaymentSubcategories';
import getAllowPatientSubmitRequest from '../../services/rewardConfig/getAllowPatientSubmitRequest';
import getExpenseCategories from '../../services/rewardConfig/getExpenseCategories';
import getProtocolRewardConfig from '../../services/rewardConfig/getProtocolRewardConfig';

export const usePaymentConfig = (): PaymentConfig => {
  const [paymentCategories, setPaymentCategories] = useState<
    PaymentConfigCategory[]
  >([]);
  const [paymentSubcategories, setPaymentSubcategories] = useState<
    PaymentConfigSubcategory[]
  >([]);
  const [expenseCategories, setExpenseCategories] = useState<ExpenseCategory[]>(
    []
  );

  const [protocolRewardConfig, setProtocolRewardConfig] = useState<ProtocolRewardConfig>();

  const [paymentAllowPatientSubmit, setPaymentAllowPatientSubmit] =
    useState<PaymentConfigAllowPatientSubmit>({
      allowPatientSubmitRequest: false,
    });

  const fetchCategories = async (protocol: string) => {
    const categoriesResponse = await getPaymentCategories(protocol);
    setPaymentCategories(categoriesResponse);
  };

  const fetchSubcategories = async (protocol: string, category: string) => {
    setPaymentSubcategories([]);
    setPaymentSubcategories(await getPaymentSubcategories(protocol, category));
  };

  const fetchAllowPatientSubmit = async (protocol: string) => {
    const allowPatientSubmit = await getAllowPatientSubmitRequest(protocol);
    setPaymentAllowPatientSubmit(allowPatientSubmit);
  };

  const fetchProtocolRewardConfig = async (protocolId: string) => {
    setProtocolRewardConfig(await getProtocolRewardConfig(protocolId));
  };

  const fetchExpenseCategories = async (
    protocol: string,
    paymenyCategoryId: string,
    paymenySubcategoryId: string
  ) => {
    const expenseCategoriesRes = await getExpenseCategories(
      protocol,
      paymenyCategoryId,
      paymenySubcategoryId
    );
    setExpenseCategories(expenseCategoriesRes);
  };

  return {
    data: {
      paymentCategories,
      paymentSubcategories,
      paymentAllowPatientSubmit,
      expenseCategories,
      protocolRewardConfig,
    },
    fetchCategories,
    fetchSubcategories,
    fetchAllowPatientSubmit,
    fetchExpenseCategories,
    fetchProtocolRewardConfig,
  };
};
